import { render, staticRenderFns } from "./TagsArgon.vue?vue&type=template&id=5fe21f27&"
import script from "./TagsArgon.vue?vue&type=script&lang=js&"
export * from "./TagsArgon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports